"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SwipeRightAnim = exports.SwipeLeftAnim = exports.DropUnderAnim = exports.PageAnim = exports.SlideFromRightAnim = exports.SlideFromLeftAnim = exports.SlideFromBottomAnim = exports.SlideFromTopAnim = exports.FadeInAnim = exports.DrawerAnim = exports.PopoverAnim = exports.PopoverContentAnim = exports.AccordionAnim = exports.getAnimationProps = exports.getMotionAnimation = exports.addMotionAnimation = exports.animations = void 0;
exports.animations = [];
function addMotionAnimation(motionClassName, open, closed, transition = {}) {
    var _a, _b;
    if (open.x !== undefined) {
        /* Temp fix for framer, this fixes the blur that occurs from modals. */
        open.transitionEnd = Object.assign(Object.assign({}, ((_a = open.transitionEnd) !== null && _a !== void 0 ? _a : {})), { x: 0 });
    }
    if (open.y !== undefined) {
        open.transitionEnd = Object.assign(Object.assign({}, ((_b = open.transitionEnd) !== null && _b !== void 0 ? _b : {})), { y: 0 });
    }
    open = Object.assign(Object.assign({}, open), { pointerEvents: 'auto' });
    closed = Object.assign(Object.assign({}, closed), { pointerEvents: 'none' });
    const motionAnimation = {
        exit: 'closed',
        initial: 'closed',
        animate: 'open',
        className: motionClassName,
        transition,
        variants: { open, closed },
    };
    exports.animations.push(motionAnimation);
    return motionAnimation;
}
exports.addMotionAnimation = addMotionAnimation;
function getMotionAnimation(className) {
    return exports.animations.find((ma) => ma.className === className);
}
exports.getMotionAnimation = getMotionAnimation;
function getAnimationProps(animation) {
    return {
        transition: animation.transition,
        variants: animation.variants,
        exit: 'closed',
        initial: 'closed',
        animate: 'open',
    };
}
exports.getAnimationProps = getAnimationProps;
const baseAnimationDuration = 0.5;
exports.AccordionAnim = addMotionAnimation('j-accordion-anim', { y: 0, opacity: 1 }, { y: -60, opacity: 0 }, { duration: baseAnimationDuration * 0.5 });
exports.PopoverContentAnim = addMotionAnimation('j-popover-content-anim', { y: 0, overflow: 'auto' }, { y: 60, overflow: 'hidden' }, { duration: baseAnimationDuration * 0.2 });
exports.PopoverAnim = addMotionAnimation('j-popover-anim', { opacity: 1 }, { opacity: 0 }, { duration: baseAnimationDuration * 0.2 });
exports.DrawerAnim = addMotionAnimation('j-drawer-anim', { opacity: 1, x: 0, pointerEvents: 'auto' }, { opacity: 0, x: '-300px', pointerEvents: 'none' }, { duration: baseAnimationDuration * 0.5 });
exports.FadeInAnim = addMotionAnimation('j-fade-in', { opacity: 1 }, { opacity: 0 }, { type: 'tween', ease: 'anticipate', duration: baseAnimationDuration * 0.5 });
exports.SlideFromTopAnim = addMotionAnimation('j-slide-from-top-anim', { y: 0 }, { y: '-100vh' }, { type: 'tween', ease: 'anticipate', duration: baseAnimationDuration });
exports.SlideFromBottomAnim = addMotionAnimation('j-slide-from-bottom-anim', { y: 0 }, { y: '100vh' }, { type: 'tween', ease: 'anticipate', duration: baseAnimationDuration });
exports.SlideFromLeftAnim = addMotionAnimation('j-slide-from-left-anim', { x: 0 }, { x: '-100%' }, { type: 'tween', ease: 'anticipate', duration: baseAnimationDuration });
exports.SlideFromRightAnim = addMotionAnimation('j-slide-from-right-anim', { x: 0 }, { x: '100vw' }, { type: 'tween', ease: 'anticipate', duration: baseAnimationDuration });
exports.PageAnim = {
    className: 'j-page-anim',
    transitions: { type: 'spring', ease: [0.17, 0.67, 0.83, 0.67], bounce: 0, duration: baseAnimationDuration },
    variants: { initial: { x: 0 }, exitOffset: { x: '-100vw' }, enterOffset: { x: '100vw' } },
};
exports.DropUnderAnim = addMotionAnimation('j-drop-under-anim', { opacity: 1, y: 0 }, { opacity: 0, y: -50 });
exports.SwipeLeftAnim = addMotionAnimation('j-swipe-left-anim', (maxWidth) => ({ x: maxWidth, pointerEvents: 'none' }), { x: 0, pointerEvents: 'initial' });
exports.SwipeRightAnim = addMotionAnimation('j-swipe-left-anim', (maxWidth) => ({ x: maxWidth * -1, pointerEvents: 'none' }), { x: 0, pointerEvents: 'initial' });
